import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { Empresa } from './models';

@Injectable()
export class CoreStore {
	constructor() {}

	private empresaId$ = new BehaviorSubject<number>(null);
	private empresa$ = new BehaviorSubject<Empresa>(null);
	private userEmpresas$ = new BehaviorSubject<Array<Empresa>>(null);

	set setEmpresaId(empresaId: number) {
		this.empresaId$.next(empresaId);
	}

	get getEmpresaId$(): Observable<number> {
		return this.empresaId$.asObservable().pipe(distinctUntilChanged());
	}

	get getEmpresaId(): number {
		return this.empresaId$.getValue();
	}

	set setEmpresa(empresa: Empresa) {
		this.empresa$.next(empresa);
	}

	get getEmpresa$(): Observable<Empresa> {
		return this.empresa$.asObservable().pipe(distinctUntilChanged());
	}

	get getEmpresa(): Empresa {
		return this.empresa$.getValue();
	}
	set setUserEmpresas(empresas: Empresa[]) {
		this.userEmpresas$.next(empresas);
	}

	get getUserEmpresas$(): Observable<Empresa[]> {
		return this.userEmpresas$.asObservable().pipe(distinctUntilChanged());
	}

	get getUserEmpresas(): Empresa[] {
		return this.userEmpresas$.getValue();
	}
}
